<template>
  <div
    id="main-wrapper"
    data-layout="vertical"
    data-navbarbg="skin5"
    :data-sidebartype="sidebarType"
    data-sidebar-position="absolute"
    data-header-position="absolute"
    data-boxed-layout="full"
  >
    <admin-header/>
    <admin-sidebar/>
    <div class="page-wrapper">
      <div v-if="!hasPermissionToViewPage" class="no-access-text text-danger font-24 font-weight-bold">
        Sorry! <br>
        You don't have permission to view this page.
      </div>
      <router-view v-else/>
    </div>
  </div>
</template>

<script>
import AdminHeader from "../components/AdminHeader";
import AdminSidebar from "../components/AdminSidebar";

export default {
  name: "Admin",
  components: {AdminSidebar, AdminHeader},
  data() {
    return {
      windowWidth: window.innerWidth,
    }
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  computed: {
    sidebarType() {
      return this.windowWidth < 1170 ? "mini-sidebar" : "full";
    },
    hasPermissionToViewPage() {
      if (this.$route.meta.admin_permissions) {
        return this.$store.getters["auth/hasAdminPermissions"](
            this.$route.meta.admin_permissions
        );
      }

      return true;
    },
  },
  created() {
    let head = document.head,
        link = document.createElement("link"),
        assetsVersion = document.querySelector("meta[name='assets-version']");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = `/css/admin.css?v=${assetsVersion.content}`;
    link.id = "gl-admin-css";
    head.appendChild(link);
    window.addEventListener("resize", this.onResize);
    //Sync data.
    this.$store.dispatch('data/syncUserRoles');
    this.$store.dispatch('data/syncCompanyStatuses');
    this.$store.dispatch('data/syncListingStatuses');
    this.$store.dispatch('data/syncLicenseTypes');
    this.$store.dispatch('data/syncCategoryTypes');
    this.$store.dispatch('data/syncCategories');
    this.$store.dispatch('data/syncSubcategories');
    this.$store.dispatch('data/syncStrainTypes');
    this.$store.dispatch('data/syncStrains');
    this.$store.dispatch('data/syncProductionTypes');
    this.$store.dispatch('data/syncOrderStatuses');
    this.$store.dispatch('data/syncOrderTypes');
    this.$store.dispatch('data/syncOrderSources');
    this.$store.dispatch('data/syncAdminNotifications');
  },
  destroyed() {
    document.getElementById('gl-admin-css').remove();
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style lang="scss" scoped>
  .no-access-text{
    text-align: center;
    padding: 20px;
  }
</style>
